import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Field, Form, formValueSelector, propTypes, reduxForm } from 'redux-form';
import { load as loadEquipmentsAction } from '../../../../reducers/equipment/equipment.actions';
import { groupedActiveEquipment as getEquipments } from '../../../../reducers/equipment/equipment.reducer';
import { load as loadLaborClassesAction } from '../../../../reducers/laborClasses/laborClasses.actions';
import {
  remove as removeAction,
  save as saveAction,
} from '../../../../reducers/workOrder/equipmentTimesheets/equipmentTimesheets.actions';
import TTFormGroup from '../../../Forms/TTFormGroup/TTFormGroup';
import SpinnerButton from '../../../SpinnerButton/SpinnerButton';
import './EquipmentTimesheetForm.css';
import CategorySelectFormGroup from '../../../Forms/CategorySelectFormGroup/CategorySelectFormGroup';

// eslint-disable-next-line object-curly-newline
export class EquipmentTimesheetForm extends React.Component {
  componentDidMount() {
    this.props.loadEquipments();
  }

  render() {
    const {
      equipments,
      remove,
      equipment: { id, removing },
      handleSubmit,
      save,
      disabled,
      currentEquipmentId,
    } = this.props;
    const currentEquipment = equipments.filter(a => a.id === parseInt(currentEquipmentId, 10))[0];
    const isOther = currentEquipment && currentEquipment.name === 'Other';
    const onFieldChange = () => setTimeout(handleSubmit(params => save(params)));


    return (
      <Form
        onSubmit={() => {}}
        onChange={onFieldChange}
      >
        <Row>
          <Col sm={4} >
            <Field
              component={CategorySelectFormGroup}
              name="equipment_id"
              label="Equipment"
              options={equipments}
              required
              disabled={disabled}
              onFieldChange={onFieldChange}
            />
          </Col>
          <Col sm={2} >
            <Field
              component={TTFormGroup}
              name="equipment_hours"
              label="Hours Used"
              type="text"
              required
              disabled={disabled}
            />
          </Col>
          <Col sm={3} >
            <Field
              component={TTFormGroup}
              name="subcontractor_hours"
              label="Machine Total Hours"
              type="text"
              disabled={disabled}
            />
          </Col>
          { !isOther &&
          <Col sm={1} >
            <SpinnerButton
              className="removeButton"
              bsStyle="danger"
              onClick={() => remove(id)}
              isLoading={removing}
              disabled={disabled}
            >
              -
            </SpinnerButton>
          </Col>
          }
        </Row>
        { isOther &&
        <Row>
          <Col sm={11} >
            <Field
              component={TTFormGroup}
              name="other_name"
              label="Other Name"
              type="text"
              required
              disabled={disabled}
            />
          </Col>
          <Col sm={1} >
            <SpinnerButton
              className="removeButton"
              bsStyle="danger"
              onClick={() => remove(id)}
              isLoading={removing}
              disabled={disabled}
            >
              -
            </SpinnerButton>
          </Col>
        </Row>
        }
      </Form>);
  }
}

EquipmentTimesheetForm.propTypes = {
  ...propTypes,
  equipments: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  remove: PropTypes.func.isRequired,
};

export const mapStateToProps = (state, ownProps) => ({
  initialValues: ownProps.equipment,
  form: `equipment${ownProps.equipment.id}`,
  equipments: getEquipments(state),
  currentEquipmentId: formValueSelector(`equipment${ownProps.equipment.id}`)(state, 'equipment_id'),
});

export const mapDispatchToProps = dispatch => ({
  remove: id => dispatch(removeAction(id)),
  loadEquipments: () => dispatch(loadEquipmentsAction()),
  loadLaborClasses: () => dispatch(loadLaborClassesAction()),
  save: values => dispatch(saveAction(values)),
});

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({ enableReinitialize: true })(EquipmentTimesheetForm));



// WEBPACK FOOTER //
// ./src/components/WorkOrder/EquipmentTimesheets/EquipmentTimesheetForm/EquipmentTimesheetForm.jsx